import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute, ParamMap, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { CityService } from '../../services/city.service';
import { Observable } from 'rxjs/Observable';
import { CommonModule } from "@angular/common"
import { Location } from "@angular/common";
import { fadeAnimation } from "../../fade.animation";
import { DomSanitizer } from '@angular/platform-browser';
import * as Chart from 'chart.js'
import { FilterPipe } from '../../services/FilterPipe';
import { placeRowComponent } from '../blocks/placeRow/placeRow.component'
import { NgProgress } from 'ngx-progressbar';

@Component({
  selector: "place",
  templateUrl: './place.component.html',
  styleUrls: ["./place.component.scss"]
})
export class PlaceComponent implements OnInit, AfterViewInit {

  canvas: any;
  ctx: any;
  barChart: any;
  public barChartColor = ['#4F687C', '#748D9E', '#88A8BA', '#B6D2DB', '#efefef'];
  barChartLabels: string[] = ['שירותי תכנון ובנייה','נגישות אתר הרשות', 'שירותים לעסק', 'שירותים לתושב', 'ציון סופי'];
  filterargs = {}
  selectedCityObject: any = [];


  //public barChartType: string = 'bar';
  public barChartLegend: boolean = false;

  public barChartData: any[] = [

  ]
  isDuplicate: boolean = false;
  socioEconomicTitle = this.cityService.socioEconomicTitle;
  placaeId: string = '';
  citySerach: string = '';
  citySerachToCompare: string = '';
  //dataModel: any = [];

  selectedLocalGovernment: any = [];
  selectedSocioEconomicCluster: any = [];
  selectedDistrict: any = [];
  selectedCityModel :any= [];
  //YearAvgData = [];

  public cities: Array<any>;

  localGovernments = Array.from(this.cityService.localGovernments);
  districts = Array.from(this.cityService.districts);
  indexs = Array.from(this.cityService.indexs);



  onOut() {
    //console.log("Value after losing focus  is");
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .map(term => term === '' ? []
        : this.cities.filter(v => v.Name.toLowerCase().lastIndexOf(term.toLowerCase()) === 0).slice(0, 10));

  formatter = (x: { Name: string }) => x.Name;

  selectedCityToCompareItem(item: any) {
    //debugger
   
    this.cityService.getCityInfo(item.item.CityId)
      .subscribe(data => {
        data.data.Name = item.item.Name,
        (<HTMLInputElement>document.getElementById("cityToComparetxt")).value = '',  
        data.data.type = 'cityToCompare',
          this.insertChartData(data.data)
          
      });

      
  }

  updateDistrict(district) {
    this.clearEconomicClusterCheckbox();
    this.selectedDistrict = district;
    this.filter();
  }

  updateSocioEconomicCluster(event) {

    if (event.target.checked) {
      if (this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue) < 0) {
        this.selectedSocioEconomicCluster.push(event.target.defaultValue);

      }
    } else {
      if (this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue) > -1) {
        this.selectedSocioEconomicCluster.splice(this.selectedSocioEconomicCluster.indexOf(event.target.defaultValue), 1);
      }
    }
  }

  updatelocalGovernment(val) {
    this.clearEconomicClusterCheckbox();
    this.selectedLocalGovernment = val;
    this.filter();
  }
  selectedItemSticky(item: any) {
    //this.clickedItem=item.item;
    debugger

    this.router.navigate(['/Place/', item.item.CityId]);

    //this.router.navigate(['/Place',item.item.CityId]);
    //this.cityService.getCityInfo(item.item.CityId)
    //.subscribe(data => { /*this.cityUrlModel = data.data*/this.dataModel.push(data.data); });

  }


  public constructor(
    private route: ActivatedRoute, private router: Router, public cityService: CityService,
    private location: Location, public sanitizer: DomSanitizer, public ngProgress: NgProgress) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  onClickGetQueryData() {
    (<HTMLInputElement>document.getElementById("showBtn")).disabled = true;
    this.cityService.getPercent(this.selectedDistrict.value, this.selectedLocalGovernment.value, this.selectedSocioEconomicCluster.toString())
      .subscribe(data => {
        (<HTMLInputElement>document.getElementById("showBtn")).disabled = false;
        this.setData(data.data[0]);
        this.filter();
      });
  }

  checkDuplicate(data: any) {
    debugger;
    for (let index = 0; index < this.barChartData.length; index++) {

      if (data.Name == this.barChartData[index].name)
        return this.isDuplicate = true;
    }
    this.isDuplicate = false
  }

  setData(data: any) {
debugger
    data.Name = this.getHeaderText();
    data.type = 'query';

    //this.checkDuplicate(data);

    //if (!this.isDuplicate) {
    this.insertChartData(data);
    //}
    this.selectedDistrict = this.districts[0];
    this.selectedLocalGovernment = this.localGovernments[0];
    this.clearEconomicClusterCheckbox();
  }

  isFormValid() {
    return (this.selectedDistrict.value != '') || (this.selectedLocalGovernment.value != '') || (this.selectedSocioEconomicCluster.length > 0)
  }

  getHeaderText() {
    let title = ''


    if (this.selectedDistrict.value != '') {
      title = this.selectedDistrict.viewValue;
    }

    if (this.selectedLocalGovernment.value != '') {
      title += this.selectedDistrict.value != '' ? ', ' : ''
      title += this.selectedLocalGovernment.viewValue;
    }

    if (this.selectedSocioEconomicCluster.length > 0) {
      title += title != '' ? ', ' : ''
      title += this.socioEconomicTitle = ' אשכול ' + this.selectedSocioEconomicCluster.toString();
    }

    return title;
  }


  public ngOnInit(): void {
    this.filterargs['dataType'] = 'cityToCompare';
    this.initBarChart();
    Chart.defaults.global.defaultFontSize = 17;
    Chart.defaults.global.showLines = false;

    Chart.defaults.global.defaultFontFamily = "Open Sans Hebrew", "Open Sans";
    let id = this.route.snapshot.paramMap.get('id');

    this.districts.unshift({ viewValue: 'כלל המחוזות', value: '' });
    this.localGovernments.unshift({ viewValue: 'בחירת סוג רשות', value: '' });
    //this.indexs.unshift({ viewValue: 'בחירת עשירון', value: '', enable: true, checked: false });

    this.selectedDistrict = this.districts[0];
    this.selectedLocalGovernment = this.localGovernments[0];
    //this.selectedSocioEconomicCluster = this.indexs[0];

    //this.filter();

    if (id) {
      this.ngProgress.start();
      this.placaeId = this.route.snapshot.paramMap.get('id');

      this.cityService.getTotalAvgAndCity(this.placaeId).subscribe(data => {
        data[0].type = 'selectedCity';
        this.selectedCityObject = data[0];
       debugger; 
       (<HTMLInputElement>document.getElementById("searchStickyTxt")).value =this.selectedCityObject.Name; 
       (<HTMLInputElement>document.getElementById("searchHeaderTxt")).value =''; 
        //this.citySerachToCompare = this.selectedCityObject.Name;
        this.insertChartData(data[0]);
        debugger
        //this.dataModel.push(data[0]);
        data[1].Name = 'ממוצע כלל ארצי'
        data[1].type = 'query';
        this.insertChartData(data[1]);
        this.cities = data[2];
        this.filter();
        this.ngProgress.done();
      });
      //(<HTMLInputElement> document.getElementById("cityToComparetxt")).value = this.selectedCityObject.Name; 
    }

    else {
      this.ngProgress.start();
      this.selectedCityObject = [];
      this.cityService.getTotalAvg().subscribe(data => {
        debugger;
        data[0].Name = 'ממוצע כלל ארצי'
        data[0].type = 'query';
        this.insertChartData(data[0]);
        this.cities = data[1];
        this.ngProgress.done();
        //this.initBarChart();
      })

      //this.initChart();

    }

    //this.cityService.getCities()
    //.subscribe(data => { this.cities = data });

    //this.cityService.getYearAvg()
    //.subscribe(data => { this.YearAvgData = data.data });

    //.switchMap((params: ParamMap) =>
    //this.service.getHero(params.get('id')));

  }

  initBarChart() {


    this.canvas = document.getElementById('barChart');
    this.ctx = this.canvas.getContext('2d');

    this.barChart = new Chart(this.ctx, {
      type: 'bar',

      data: {
        labels: this.barChartLabels,
        datasets: this.barChartData
      },
      options: this.barChartOptions
    });

  }

  public ngAfterViewInit(): void {
  }

  /*
    public barChartOptions: any = {
      tooltips: {
        enabled: true,
        fontFamily: "Open Sans Hebrew",
      },
      responsive: true,
      maintainAspectRatio: true,
      hover: {
        animationDuration: 3
      },
      animation: {
        //duration: 3,
        onComplete: function () {
          var chartInstance = this.chart,
          ctx = chartInstance.ctx;
          ctx.textAlign = 'center';
          //ctx.font =''
          ctx.fontSize = '25';
          ctx.fontStyle='bold';
          //ctx.fillStyle = "rgba(0, 0, 0, 1)";
          ctx.textBaseline = 'bottom';
          console.log(ctx);
          this.data.datasets.forEach(function (dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
              var data = dataset.data[index];
              ctx.fillText(data, bar._model.x, bar._model.y - 5);
  
            });
          });
        }
      },
      plugins: {
        datalabels: {
          display: true,
          anchor: 'end',
          align: 'end',
          backgroundColor: null,
          borderColor: null,
          borderRadius: 4,
          borderWidth: 1,
          color: '#223388',
          font: function (context) {
            var width = context.chart.width;
            var size = Math.round(width / 32);
            return {
              size: 35,
              weight: 600
            };
          },
          offset: 8,
          padding: 0,
  
        }
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          barPercentage: 0.75,
          categoryPercentage: 0.7,
          //maxBarThickness: 80,
          ticks: {
            beginAtZero: true,
            fontStyle:'bold',
            fontSize: 27,
            fontFamily: "Open Sans Hebrew",
            fontColor: 'black',
          },
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
  
          ticks: {
            beginAtZero: true,
            display: false,
            steps: 10,
            stepValue: 5,
            max: 120
          },
          gridLines: {
            display: false
          }
        }]
      }
    };
  */

  public barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    //responsive: false,
    //maintainAspectRatio: false,
    tooltips: {
      enabled: true
    },
    hover: {
      animationDuration: 2
    },
    animation: {
      //duration: 3,
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        //ctx.font =''
        ctx.fontSize = '22';
        ctx.fillStyle = "rgba(0, 0, 0, 1)";
        ctx.textBaseline = 'bottom';
        //console.log(ctx);
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);

          });
        });
      }
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        backgroundColor: null,
        fontStyle:'bold',
        borderColor: null,
        borderRadius: 4,
        borderWidth: 1,
        color: '#223388',
        font: function (context) {
          var width = context.chart.width;
          var size = Math.round(width / 32);
          return {
            size: 35,
            weight: 600,
            //fontStyle :'bold'
          };
        },
        offset: 4,
        padding: 0,

      }
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [{
        barPercentage:0.7,
        categoryPercentage: 0.5,
        /*padding: {
          left: 5,
          right: 5,
        },*/
        //maxBarThickness: 40,
        ticks: {
          beginAtZero: true,
          fontSize: 20,
          fontFamily: "Open Sans Hebrew",
          fontColor: 'black',
          fontStyle :'bold'
        },
        //barThickness: 40,
        gridLines: {
          display: false
        }
      }],
      yAxes: [{
        padding: {
          left: 0,
          right: 0,
        },
        ticks: {
          beginAtZero: true,
          display: false,
          steps: 10,
          stepValue: 5,
          max: 120
        },
        gridLines: {
          display: false
        }
      }]
    }
  };
  public setCellData(data, type) {
    //console.log(data, type);

    if (type == 'selectedCity') {

      if (data == 2) {
        return 'לא רלוונטי';
      }
      else {
        return '<img src="\assets\images\"' + data + '.png" />'
      }

    }

  }


  public removeFromChartData(index: number, item: any): void {

    debugger;

    if (item.dataType == 'selectedCity') {
      this.selectedCityObject = [];
      (<HTMLInputElement>document.getElementById("searchStickyTxt")).value ='';
    }

    this.barChartData.splice(index, 1);
    this.barChart.chart.update();

  }

  public getColor(data: any) {
    let i;

    /*let usedcityToCompare=[];
    
    var res1 = this.barChartData.filter(function (el) {
      return usedcityToCompare.indexOf(el) == -1; 
      });*/
    debugger;

    if (data.type == 'selectedCity')
      return this.cityService.getBackgroundByTotal(data.TotalValue);

    let usedColor = [];

    for (i = 0; i < this.barChartData.length; i++) {
      if (this.barChartData[i].dataType != "selectedCity")
        usedColor.push(this.barChartData[i].backgroundColor)
    }

    if (data.type == 'cityToCompare') {
      var cityToCompare: any = this.barChartData.filter(function (data) {
        return data.dataType == 'cityToCompare'
      });

      if (cityToCompare.length == 0)
        return '#344E60'
    }
    var res = this.barChartColor.filter(function (el) {
      return usedColor.indexOf(el) == -1;
    });

    return res[0];

  }

  public insertChartData(data: any): void {

    this.checkDuplicate(data);

    if (!this.isDuplicate) {

      let color = this.getColor(data);

      let item = {
        obj: data,
        dataType: data.type,
        label: data.Name,
        name: data.Name,
        borderColor: color,
        data: 
        [data.EngineeringTotal,
         data.SiteAccessibilityTotal,
        data.LocalBusinessTotal,
        data.ResidentTotal,
        data.TotalValue],
        backgroundColor: color
      };

      if (data.type == 'cityToCompare') {
        this.barChartData.splice(this.getIndexPlaceForcityToCompare(), 0, item);
      }
      else {
        this.barChartData.push(item);
      }

      this.barChart.chart.update();
    };
  }

  getColomnNumberForHeader() {
    let index = this.getIndexPlaceForcityToCompare();
    return this.barChartData.length - index;
  }


  getIndexPlaceForcityToCompare() {
    let counter = 0;
    for (let _i = 0; _i < this.barChartData.length; _i++) {
      if (this.barChartData[_i].dataType == 'selectedCity' || this.barChartData[_i].dataType == 'cityToCompare')
        counter++;
    }
    return counter;
  }

  // events
  public chartClicked(e: any): void {
    //console.log(e);
  }


  public chartHovered(e: any): void {
    //console.log(e);
  }


  filter() {


    debugger;
    let filteredCities = [];


    let filters = {
    };

    //if (this.selectedDistrict) {
    if (this.selectedDistrict.value && this.selectedDistrict.value != "") {
      filters['District'] = this.selectedDistrict.value;
    }
    //}

    //if (this.selectedLocalGovernment) {
    if (this.selectedLocalGovernment.value && this.selectedLocalGovernment.value != "") {
      filters['LocalGovernment'] = this.selectedLocalGovernment.value;
    }

    let filteredCitiesByLocalAndDiscrit = this.cityService.multiFilter(this.cities, filters);
    for (let _i = 0; _i < filteredCitiesByLocalAndDiscrit.length; _i++) {

      //if (filteredCitiesByLocalAndDiscrit[_i].District == this.selectedDistrict.value || this.selectedDistrict.value == 'הכל') {
      let SocioEconomicCluster = filteredCitiesByLocalAndDiscrit[_i].SocioEconomicCluster;
      this.cityService.indexs[SocioEconomicCluster - 1].enable = true;
      //}
    }
  }

  getSocioEconomicTitle() {

    if (this.selectedSocioEconomicCluster.length == 0)
      this.socioEconomicTitle = this.cityService.socioEconomicTitle;

    else {

      this.socioEconomicTitle = ' אשכול ' + this.selectedSocioEconomicCluster.toString();
    }

    return this.socioEconomicTitle;
  }

  clearEconomicClusterCheckbox() {
    //alert('clear');
    for (let _i = 0; _i < 10; _i++) {
      //this.indexs[_i].checked = false;
      (<HTMLInputElement>document.getElementById('checkboxIndex-' + _i)).checked = false;
      this.indexs[_i].enable = false;
    }
    this.selectedSocioEconomicCluster = [];
    //this.filter();
  }

}


// WEBPACK FOOTER //
// ./src/app/component/Place/place.component.ts